import {useMutation, useQueryClient} from 'react-query';
import {addMistakeOrder} from './api';

export const useAddMistakeOrder = () => {
    const queryClient = useQueryClient();

    const { mutate, isLoading, data } = useMutation(
        ['addMistakeOrder'],
        (addOrder) => addMistakeOrder(addOrder),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('1688-order-info');
            },
        },
    );

    return {
        mutate,
        isLoading,
        data,
    };
};
